import { Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@structural-climbing/auth'
import { Button, LanguageSwitcher, UpdateBanner } from '@structural-climbing/ui'

export function RootLayout() {
  const { isAuthenticated, loginWithRedirect } = useAuth()
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <UpdateBanner message={t('appUpdate.message')} actionLabel={t('appUpdate.action')} />
      {!isAuthenticated && (
        <header className="flex items-center justify-between border-b border-divider px-6 py-4">
          <span className="font-semibold text-primary">{t('brand.fullName')}</span>
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <Button size="sm" color="primary" onClick={() => loginWithRedirect()}>
              {t('common.signIn')}
            </Button>
          </div>
        </header>
      )}
      <Outlet />
    </div>
  )
}
